import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import SpecifiedCommercialTransactions from "../pages/SpecifiedCommercialTransactions";
import Thanks from "../pages/Thanks";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/commercial-transaction",
    element: <SpecifiedCommercialTransactions />,
  },
  {
    path: "/thanks",
    element: <Thanks />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
